import { MijnRoute } from '../../mijn-navigatie.model';

export const INSURANCES_PRODUCTPAGE: MijnRoute = {
    path: 'product-overview/:product/:id',
    navigationEvent: 'toVerzekerenProductPage',
    regex: /^\/verzekeren-beheren\/product-overview\/[^/]+\/[^/]+$/,
    webcomponent: 'mijn-verzekeren-beheer-webcomponent',
    internalPath: '/product-overview/:product/:id'
};
